export const ASSIGN_TRANSACTION_PRICING_OFFER_FOR_PARTNERS = gql`
    mutation AssignTransactionPricingOfferForPartners(
        $partnerIds: [Int]
        $transactionOfferId: Int!
        $type: AssignmentType!
    ) {
        updateTransactionOfferAssigneesForPartners(
            partnerIds: $partnerIds
            transactionOfferId: $transactionOfferId
            type: $type
        ) {
            id
            offerName
        }
    }
`;

export const ASSIGN_TRANSACTION_PRICING_OFFER_FOR_PARTNERS_OF_PARTNER = gql`
    mutation AssignTransactionPricingForPartnersOfPartner(
        $partnerOfPartnerIds: [Int]
        $transactionOfferId: Int!
        $type: AssignmentType!
    ) {
        updateTransactionOfferAssigneesForPartnersOfPartner(
            partnerOfPartnerIds: $partnerOfPartnerIds
            transactionOfferId: $transactionOfferId
            type: $type
        ) {
            id
            offerName
        }
    }
`;
